import { PropsWithChildren, useEffect, useRef } from "react";
import { createPortal } from 'react-dom';

import { CreateOverlayProps, OverlayService } from "../service";

export const OverlayComponent = (props: PropsWithChildren<CreateOverlayProps>) => {
	const overlayElementRef = useRef(document.createElement('div'));

	useEffect(() => {
		var overlayRef = OverlayService.createOverlay(overlayElementRef.current, props);

		return () => { overlayRef.destroy(); };		
	}, []);

	return createPortal(props.children, overlayElementRef.current);
}
